var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYahoo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 50C38.8071 50 50 38.8071 50 25C50 11.1929 38.8071 0 25 0C11.1929 0 0 11.1929 0 25C0 38.8071 11.1929 50 25 50Z",
    fill: "#5F01D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18.8473H18.139L21.1222 26.5055L24.149 18.8473H29.1574L21.6231 37H16.5929L18.6616 32.2L13 18.8473ZM29.9196 26.1127C31.6399 26.1127 33.0335 27.5091 33.0335 29.2327C33.0335 30.9564 31.6399 32.3527 29.9196 32.3527C28.1994 32.3527 26.8057 30.9564 26.8057 29.2327C26.8057 27.5091 28.1994 26.1127 29.9196 26.1127ZM34.057 24.9782H28.4607L33.4255 13H39L34.057 24.9782Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahoo);
export default __webpack_public_path__ + "static/media/Yahoo.cd0c415f116afc98e7aab3c935a54e6a.svg";
export { ForwardRef as ReactComponent };